import { Collaboration } from '@range.io/basic-types'
import { LookupTable, memoizeOnce } from '@range.io/functional'
import memoizeResult from '../../memoize-result.js'
import { _field } from '../../selector-primitives.js'
import FeatureSelectors from '../feature-slice/feature-selectors.js'

const collaborationsAsArray = memoizeResult(state => Object.values(state.collaborations))
const _collaborationsAsLookupTable = state => LookupTable(Object.values(state.collaborations), Collaboration)
const collaborationsAsLookupTable = memoizeOnce(state => state.collaborations, _collaborationsAsLookupTable)
const collaborationsAsObject = _field('collaborations')

/*
 * Return all the Collaborations for the currently-selected Feature
 * @sig _collaborationsForSelectedFeature :: State -> [Collaboration]
 */
const _collaborationsForSelectedFeature = state => {
    const featureId = state.selectedFeatureId
    return collaborationsAsArray(state).filter(c => c.featureId === featureId)
}

/*
 * Return the first Collaboration for the currently-selected Feature
 * @sig firstCollaborationForSelectedFeature :: State -> Collaboration
 */
const firstCollaborationForSelectedFeature = state => {
    const featureId = state.selectedFeatureId

    return featureId ? _collaborationsForSelectedFeature(state)[0] : undefined
}

/*
 * Return the first Collaboration for the given geometryId
 * @sig firstCollaborationForGeometry :: State -> Collaboration
 */
const firstCollaborationForGeometry = (state, geometryId) => {
    const feature = FeatureSelectors.firstFeatureForGeometryId(state, geometryId)
    return feature ? collaborationsAsArray(state).find(c => c.featureId === feature.id) : null
}

// return the Collaboration for the upload
const collaborationForUpload = (state, upload) => collaborationsAsArray(state).find(c => upload?.parentId === c.id)

const collaborationWithId = (state, collaborationId) => state.collaborations[collaborationId]

// ---------------------------------------------------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------------------------------------------------
const CollaborationSelectors = {
    collaborationForUpload,
    collaborationsAsObject,
    collaborationsAsLookupTable,
    collaborationsAsArray,
    collaborationWithId,
    firstCollaborationForGeometry,
    firstCollaborationForSelectedFeature,
}

export default CollaborationSelectors
